/* eslint-disable import/extensions,react/jsx-closing-tag-location,react/destructuring-assignment,react/jsx-no-bind */
import React, { Component } from 'react';
import { Table, message, Modal, Radio, Alert } from 'antd';
import { connect } from 'dva';
import Container from '@/components/Container';

import style from './index.less';

@connect(({ settings }) => ({
  ...settings,
}))
class BasicNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      loading: true,
      visibleModal: false,
      modalData: '',
      modifyData: {},
    };
  }

  componentDidMount() {
    this.handleInitData()
  }

  handleInitData = () => {
    const { dispatch } = this.props || {};
    dispatch({
      type: 'settings/fetchGetMessage'
    }).then(res => {
      const { data, code, msg } = res && res || {};
      if (code === 0 || code === 200) {
        this.setState({
          loading: false,
          tableData: data && data.appList || [],
        });
        return true;
      }
      message.error(msg);
      return false;
    });
  }

  // 点击显示对应的弹出框
  showModal = (item) => {
    this.setState({
      modifyData: item,
      modalData: item,
      visibleModal: true
    })
  }

  // 点击弹出框确定
  handleUpdateInfo = () => {
    const { appId, enable, fromApp } = this.state.modifyData || {};
    const { dispatch } = this.props || {};
    dispatch({
      type: 'settings/fetchSaveMessage',
      payload: {
        appId,
        enable,
        fromApp
      }
    }).then(res => {
      const { code, msg } = res && res || {};
      if (code === 0 || code === 200) {
        message.success('设置成功！');
        this.handleInitData();
        this.setState({
          visibleModal: false
        });
        return true;
      }
      message.error(msg);
      return false;
    });
  }

  onRadioChange = e => {
    const { modalData } = this.state;
    const modifyData = JSON.parse(JSON.stringify(modalData))
    modifyData.enable = e.target.value
    this.setState({
      modifyData
    });
  }

  handleCancel() {
    this.setState({
      visibleModal: false
    })
  }

  render() {
    const { visibleModal, modalData, modifyData } = this.state
    const columns = [
      {
        title: <div style={{paddingLeft: 10}}>应用名称</div>,
        dataIndex: 'appName',
        key: 'appName',
        width: '33%',
        render: (text) => {
          return <div style={{paddingLeft: 10}}>{text}</div>
        }
      },
      {
        title: '是否推送',
        dataIndex: 'enable',
        key: 'enable',
        width: '33%',
        render: (text, item) => {
          if (item.isAvailable === 1) {
            return item.enable === 1 ? '是' : '否'
          }
          return '-'
        }
      },
      {
        title: '操作',
        key: 'operation',
        width: '33%',
        render: (text, item) => (
          <span>
            {
              item.isAvailable === 1 ? <a onClick={this.showModal.bind(this, item)}>修改</a> : <span className='disableEdit'>编辑</span>
            }
          </span>
        )
      }
    ];

    return (
      <Container breStates={!0} version={2}>
        <div className={style.message}>
          <div className={style['message-alert']}>
            <Alert message="请选择默认接收消息的应用，勾选的应用将对用户进行消息推送" type="info" showIcon />
          </div>
          <div className={style.tab}>
            <Table
              columns={columns}
              dataSource={this.state.tableData}
              rowKey={record => record.roleId}
              loading={this.state.loading}
            />
          </div>
          <Modal
            title={`${modalData.appName}编辑`}
            visible={visibleModal}
            onOk={this.handleUpdateInfo}
            onCancel={this.handleCancel.bind(this)}
          >
            <div>
              是否推送：
              <Radio.Group onChange={this.onRadioChange.bind(this)} value={modifyData.enable}>
                <Radio value={1}>是</Radio>
                <Radio value={0}>否</Radio>
              </Radio.Group>
            </div>
          </Modal>
        </div>
      </Container>
    );
  }
}

export default BasicNews;
